import { HTTPStatuses } from '@packages/domain/constants/http';
import { isSessionExpiredError } from '@packages/domain/utils/errors/errors';
import { cleanUnauthorizedUserData, refreshToken } from 'actions';
import { getAccessToken, getExpiresIn, isLoggedIn } from 'selectors';
import { date } from 'utils/date/date';
import { fetchJson } from 'utils/fetchJson/fetchJson';

let storeInstance = null;

export const setStore = store => {
  storeInstance = store;
};

const fetch = async (url, options) => {
  if (storeInstance && storeInstance.get()) {
    const state = storeInstance.get().getState();

    if (isLoggedIn(state)) {
      const authHeaders = await getAuthHeaders(state);
      options.headers = { ...authHeaders, ...options.headers };
    }
  }

  return fetchJson(url, options).catch(handleFetchError);
};

const handleFetchError = error => {
  const { status } = error;

  if (storeInstance && storeInstance.get()) {
    const { dispatch } = storeInstance.get();

    if (status === HTTPStatuses.UNAUTHORIZED && isSessionExpiredError(error)) {
      dispatch(cleanUnauthorizedUserData());
    }
  }

  throw error;
};

const getAuthHeaders = async state => {
  try {
    const accessToken = isTokenExpired(state)
      ? await getNewToken(state)
      : getAccessToken(state);

    return { Authorization: `Bearer ${accessToken}` };
  } catch (_e) {
    const { dispatch } = storeInstance.get();
    dispatch(cleanUnauthorizedUserData());

    return {};
  }
};

const isTokenExpired = state => {
  const expiresIn = getExpiresIn(state);
  if (!expiresIn) {
    return false;
  }

  const oneMinuteFromNow = date.future(1, date.MINUTES);
  const expirationDate = date.fromUnix(expiresIn);

  return date.isBefore(expirationDate, oneMinuteFromNow);
};

const getNewToken = async _state => {
  const { payload } = await storeInstance.get().dispatch(refreshToken());
  const { accessToken } = payload;

  return accessToken;
};

export { fetch };
